import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    width: 100%;
    background-color: ${theme.palette.white.light};
  `}
`;

export const LoaderWrapper = styled.div`
  width: 120px;
  display: flex;
  justify-content: center;
  position: relative;
`;

export const ProgressBarContainer = styled.div`
    background-color: #E7F3FD;
    border-radius: 4px;
    height: 6px;
    width: 120px;
    position: absolute;
    bottom: 0px;
    z-index: 2;
`;

export const Progress = styled.div`
  ${({ percentage }) => css`
    background-color: #74C1FF;
    border-radius: 4px;
    height: 100%;
    width: ${`${percentage}%`};
    transition: width 0.4s ease-out;
  `}
`;

export const LoaderText = styled.p`
  ${({ theme }) => css`
    color: ${theme.palette.primary.darkest};
    font-family: ${theme.font.family.secondary};
    font-size: 14px;
    font-weight: ${theme.font.weights.bold};
    letter-spacing: 0px;
    line-height: 21px;
    margin: 8px 0px 0px 0px;
  `}
`;
